/**
 * 将相对 API 地址绑定到当前 Web 站点，供 iframe/WebView 参数安全使用。
 * 已经是完整域名的地址保持不变。
 */
export const resolveApiUrl = (url: string, origin: string): string => {
  if (!url || !origin || !url.startsWith('/')) {
    return url;
  }

  return `${origin.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`;
};
